import type { LinkDef } from '@hanzo/ui/types'

/**
 * The target and rel an anchor gets for a LinkDef: away from the site opens a
 * new tab with the referrer cut, unless `newTab: false` says stay; a same-site
 * link stays unless `newTab` says otherwise. Matches @hanzo/ui's LinkElement.
 */
export const anchor = (l: Pick<LinkDef, 'href' | 'external' | 'newTab'>) => {
  const away = l.external ?? /^(https?:|mailto:|tel:)/.test(l.href)
  const blank = l.newTab ?? away
  return blank ? { target: '_blank', rel: 'noopener noreferrer' } : {}
}
